import * as _ from 'lodash';
import * as types from '@/store/mutationTypes';
import { initialState } from '@/store/initialState';

export const mutations = {
    [types.SET_CHILDREN](state, children) {
        state.children = children;
    },

    [types.SET_CHILD_ID](state, childId) {
        state.childId = childId;
    },

    [types.SET_CHILD_INFO](state, childInfo) {
        state.childInfo = childInfo;
    },

    [types.SET_CHILD_SCHEDULE_INFO](state, childScheduleInfo) {
        state.childScheduleInfo = childScheduleInfo;
    },

    [types.SET_CHILD_PHOTO](state, childPhoto) {
        state.childPhoto = childPhoto;
    },

    [types.SET_CHILD_INFO_FOR_EDIT](state, childInfoForEdit) {
        state.childInfoForEdit = childInfoForEdit;
    },

    [types.RESET_CHILD_INFO_FOR_EDIT](state) {
        _.keys(initialState.children.childInfoForEdit).forEach(key => {
            state.childInfoForEdit[key] = initialState.children.childInfoForEdit[key];
        });
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/children/mutations.js